module.exports = __webpack_public_path__ + "static/media/18.6386eae2.jpg";